import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'

import { dmsState } from '@/app/store'

import { List } from './List/List'

export const Insureds = observer(() => {
    useEffect(
        () => () => {
            dmsState.onSetChosenInsured(null)
            dmsState.onSetCompanyContracts(null)
            dmsState.onSetCompanyPrograms(null)
        },
        []
    )

    return <List />
})
